/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import useMortarElectirc from '../hooks/useMortarElectirc';
import useProDataTrend from '../hooks/useProDataTrend';
import { BarEchartMul } from '@/components/page-echarts';
import hyRequest from '@/service';
// window.toDetail = function (params) {
// }
export default defineComponent({
  name: 'ProdAggregateAccount',
  components: {
    BarEchartMul: BarEchartMul
  },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props) {
    var emptyStringFormat = useEmptyStringFormat();
    // 选择日期
    var confrimDate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.date = val;
              getMortarElectricAsync();
              getMortarElectricTrendAsync();
              getMortarElectricYearTrendAsync();
              getMortarSumGroup();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confrimDate(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var dateRef = ref();
    var params = ref({
      type: props.type,
      date: dayjs().format('YYYY/MM/DD')
    });
    //获取砂浆产量汇总列表
    var mortarSumGroup = ref([]);
    function getMortarSumGroup() {
      hyRequest.post({
        url: '/product/mortarSumGroup',
        data: params.value
      }).then(function (data) {
        mortarSumGroup.value = data.list;
      });
    }
    watch(function () {
      return props.type;
    }, function (newVal) {
      var _dateRef$value;
      params.value.type = newVal;
      params.value.date = dayjs().format('YYYY/MM/DD');
      //把所以日期控件的日期变为当前最新日期
      (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
      mortarElectircTrend.value.splice(0);
      mortarElectircYearTrend.value.splice(0);
      getMortarElectricAsync();
      getMortarElectricTrendAsync();
      getMortarElectricYearTrendAsync();
      getMortarSumGroup();
    });
    var title = computed(function () {
      var text = '';
      if (props.type === 1) {
        text = '周';
      }
      if (props.type === 2) {
        text = '月';
      }
      if (props.type === 3) {
        text = '年度';
      }
      return text;
    });
    //获取商砼吨耗电数
    var _useMortarElectirc = useMortarElectirc(params),
      _useMortarElectirc2 = _slicedToArray(_useMortarElectirc, 2),
      mortarElectric = _useMortarElectirc2[0],
      getMortarElectricAsync = _useMortarElectirc2[1];
    var summaryData = computed(function () {
      var text = '';
      if (props.type === 1) {
        text = '周';
      }
      if (props.type === 2) {
        text = '月';
      }
      if (props.type === 3) {
        text = '年';
      }
      console.log(text);
      return [{
        num: mortarElectric.value.totalSettleValue,
        desc: "\u4EA7\u91CF/\u5428"
      }, {
        num: mortarElectric.value.electric,
        desc: "\u8017\u7535\u91CF/\u5EA6"
      }, {
        num: mortarElectric.value.tonEle,
        desc: "\u5428\u8017\u7535/\u5EA6"
      }];
    });
    // [
    //   mortarElectircTrend,
    //   mortarElectircYearTrend,
    //   getMortarElectricTrendAsync,
    //   getMortarElectricYearTrendAsync
    // ]
    var _useProDataTrend = useProDataTrend(params),
      _useProDataTrend2 = _slicedToArray(_useProDataTrend, 4),
      mortarElectircTrend = _useProDataTrend2[0],
      mortarElectircYearTrend = _useProDataTrend2[1],
      getMortarElectricTrendAsync = _useProDataTrend2[2],
      getMortarElectricYearTrendAsync = _useProDataTrend2[3];
    onMounted(function () {
      getMortarElectricAsync();
      getMortarElectricTrendAsync();
      getMortarElectricYearTrendAsync();
      getMortarSumGroup();
    });
    var mainPro = computed(function () {
      var lineData1 = mortarElectircTrend.value.map(function (item) {
        return item.settle_value;
      });
      var lineData2 = mortarElectircTrend.value.map(function (item) {
        return item.electric;
      });
      var lineData3 = mortarElectircTrend.value.map(function (item) {
        return item.tonEle;
      });
      var xLabels = mortarElectircTrend.value.map(function (item) {
        return item.time;
      });
      var legendData = ['产量', '耗电量', '吨耗电'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2, lineData3],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324', '#00B2F4'],
        grid: {
          left: 70,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(['产量'].includes(item.seriesName) ? '吨' : '度', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var mainProYear = computed(function () {
      var lineData2 = mortarElectircYearTrend.value.map(function (item) {
        return item.settle_value;
      });
      var lineData3 = mortarElectircYearTrend.value.map(function (item) {
        return item.electric;
      });
      var lineData4 = mortarElectircYearTrend.value.map(function (item) {
        return item.tonEle;
      });
      var xLabels = mortarElectircYearTrend.value.map(function (item) {
        return item.time;
      });
      var legendData = ['产量', '耗电量', '吨耗电'];
      return {
        xLabels: xLabels,
        lineData: [lineData2, lineData3, lineData4],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324', '#00B2F4'],
        grid: {
          left: 70,
          top: 60,
          bottom: 30,
          right: 20
        },
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(['产量'].includes(item.seriesName) ? '吨' : '度', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    return {
      emptyStringFormat: emptyStringFormat,
      mortarElectric: mortarElectric,
      summaryData: summaryData,
      mainPro: mainPro,
      mainProYear: mainProYear,
      title: title,
      params: params,
      confrimDate: confrimDate,
      dateRef: dateRef,
      mortarSumGroup: mortarSumGroup
    };
  }
});